import { BookButton } from './book-button';
import { useSchedulingPro } from './scheduling-pro-provider';

export const SchedulingProWidget = () => {
    const { schedulingProScriptLoadedSuccessfully } = useSchedulingPro();
    const handleClick = () => {
        window._scheduler?.show();
    };

    return schedulingProScriptLoadedSuccessfully && <BookButton onClick={handleClick} />;
};
